<template>
 <div class="turntable-container">
    <img class="container-bg" :src="$getImgUrl('/img/activity/refuel/refuel2-bg.png')" alt="">
    <div class="refuel-info">
      我的油量：<span class="sp">{{remaining}}ml</span>
    </div>
     <!-- 点击时候转动转盘 指针不转 -->
    <div class="turntable-box">
      <img class="turntable-bg" :src="$getImgUrl('/img/activity/refuel/refuel2-turntable-bg.png')" alt="">
      <img class="turntable-center" :style="{transform:rotateAngle,transition:rotateTransition == ''?'transform 4s ease-in-out':rotateTransition }" :src="$getImgUrl('/img/activity/refuel/refuel2-turntable.png')">
      <img class="turntable-top" @click="startLottery()" :src="$getImgUrl('/img/activity/refuel/refuel1-btn-1.png')">
      <img class="turntable-shadow" :src="$getImgUrl('/img/activity/refuel/refuel2-shadow.png')" alt="">
    </div>

    <div class="btn-box">
      <img @click="showPrize=true" :src="$getImgUrl('/img/activity/refuel/refuel2-btn-1.png')" alt="">
      <img @click="gotoWeb" :src="$getImgUrl('/img/activity/refuel/refuel2-btn-2.png')" alt="">
    </div>

    <van-overlay z-index='20' class="hasPrize-box" :show="showDialog">
      <div>
      <img class="hasPrize-bg" :src="$getImgUrl('/img/activity/refuel/refuel2-dialog.png')">
      <div class="dialog-btn">
        <img class="btn1"  @click="pointer()" :src="$getImgUrl('/img/activity/refuel/refuel2-btn-3.png')">
        <img class="btn2" @click="showDialog = false" :src="$getImgUrl('/img/activity/refuel/refuel2-btn-4.png')">
      </div>
      </div>
    </van-overlay>

    <div class="prize-container" v-if="showPrize">
      <div class="prize-box" @click.stop>
        <img
          class="close"
          @click="showPrize = false"
          src="../../../assets/images/new-year/close.png"
        />
        <img class="bg" :src="$getImgUrl('/img/activity/refuel/refuel1-bg-myPrize.png')" />
        <div class="prize-detail">
          <div class="prize-item" v-for="(item, index) of lotteryDetailList" :key="index">
            <div class="item-name">{{ item.itemName }}</div>
            <div :class="item.itemStatus == '已领取' ? 'item-status1' : 'item-status2'">
              {{ item.itemStatus }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <van-overlay :show="showPrize" z-index='20' @click="showPrize = false">
      <div class="prize-dialog" @click.stop>
        <img class="close" @click="showPrize=false" src="../../../assets/images/new-year/close.png">
        <img  class="bg" :src="$getImgUrl('/img/activity/refuel/refuel1-bg-myPrize.png')"/>
        <div class="prize-detail">
          <div class="prize-item" v-for="(item,index) of lotteryDetailList" :key="index">
            <div class="item-name">{{item.itemName}}</div>
            <div :class="item.itemStatus=='已领取'?'item-status1':'item-status2'">{{item.itemStatus}}</div>
          </div>
        </div>
      </div>
    </van-overlay> -->

    <van-overlay duration @click="showWarning1 = false" z-index='20' class="hasPrize-box" :show="showWarning1">
      <div>
      <img class="hasPrize-bg" :src="$getImgUrl('/img/activity/refuel/refuel2-warning-1.png')" >
      </div>
    </van-overlay>

    <van-overlay duration @click="showWarning2 = false" z-index='20' class="hasPrize-box" :show="showWarning2">
      <div>
      <img class="hasPrize-bg" :src="$getImgUrl('/img/activity/refuel/refuel2-warning-2.png')" >
      </div>
    </van-overlay>

 </div>
</template>

<script>
import activityApi from '@/api/activity'
export default {
  data () {
    return {
      remaining: 0,
      lotteryCount: 0,
      showDialog: false,
      showWarning1: false,
      showWarning2: false,
      itemName: '',
      showPrize: false,
      lotteryDetailList: [],
      luckflag: true,
      rotateAngle: 0, // 将要旋转的角度
      startRotatingDegree: 0, // 初始旋转角度
      rotateTransition: '', // 控制过渡效果
      click_flag: true // 是否可以旋转抽奖
    }
  },
  mounted () {
    this.getRefuelInfo()
    this.getPrizeList()
  },
  methods: {
    getRefuelInfo () {
      activityApi.getRefuelInfo().then(res => {
        if (res.data.resultCode === '0') {
          this.remaining = res.data.resultData.remaining
          this.lotteryCount = res.data.resultData.lotteryCount
        }
      })
    },
    getPrizeList () {
      activityApi.getLotteryDetailList().then(res => {
        if (res.data.resultCode === '0') {
          this.lotteryDetailList = res.data.resultData.lotteryDetailList || []
        }
      })
    },
    gotoWeb () {
      this.$router.push({ name: 'activity-refuel' })
    },
    startLottery () {
      if (!this.click_flag) return
      this.showDialog = true
    },
    // 点击指针
    pointer () {
      this.showDialog = false
      if (this.remaining < 1000) {
        this.showWarning1 = true
        setTimeout(function () { this.showWarning1 = false }.bind(this), 2000)
        return
      }
      if (this.lotteryCount === 0) {
        this.showWarning2 = true
        return
      }
      this.getlotteryPrizeFun()
    },
    // 转动
    rotate (prize) { // 目前是只转动转盘
      if (!this.click_flag) return
      var type = 0 // 默认为 0  转盘转动
      var randCircle = 5 // 附加多转几圈，2-3
      var duringTime = 6 // 默认为 5s
      var rotateAngle = ''
      switch (prize.name) {
        case '8888积分':rotateAngle = randCircle * 360 + 342; break
        case '易损件魔方':rotateAngle = randCircle * 360 + 306; break
        case '登机箱':rotateAngle = randCircle * 360 + 270; break
        case '888积分':rotateAngle = randCircle * 360 + 234; break
        case '口袋笔记本':rotateAngle = randCircle * 360 + 198; break
        case '美的电饭煲':rotateAngle = randCircle * 360 + 162; break
        case '多肉加湿器':rotateAngle = randCircle * 360 + 126; break
        case '88积分':rotateAngle = randCircle * 360 + 90; break
        case '谢谢参与':rotateAngle = randCircle * 360 + 54; break
        case '博世电动工具':rotateAngle = randCircle * 360 + 18; break
      }
      this.click_flag = false // 旋转结束前，不允许再次触发
      if (type === 0) {
        // 转动盘子
        rotateAngle = this.startRotatingDegree + rotateAngle - this.startRotatingDegree % 360// 将要旋转的角度
        this.startRotatingDegree = rotateAngle// 改变初始旋转的角度
        this.rotateAngle = 'rotate(' + rotateAngle + 'deg)'// 真正控制转动角度
        // 旋转结束后允许再次触发
        setTimeout(() => {
          this.click_flag = true
          this.gameOver(prize)
        }, duringTime * 1000 + 200)
      }
    },
    gameOver () {
      this.rotateAngle = 'rotate(' + 0 + 'deg)'// 真正控制转动角度的,为0,回到初始位置
      this.rotateTransition = 'transform 0.01s ease-in-out' // 控制转动过渡效果的
      setTimeout(() => {
        this.rotateTransition = ''
      }, 100)
      // 中奖弹窗提示
      this.$dialog.alert({
        title: '提示',
        message: this.itemName === '谢谢参与' ? '很遗憾，您未抽中奖品。' : `恭喜您抽中${this.itemName}`
      }).then(() => {
        // 游戏结束,重置旋转初始位置

      })
      // 更新页面数据
      this.getRefuelInfo()
      this.getPrizeList()
    },
    // 请求点击抽奖数据,中奖操作
    getlotteryPrizeFun () {
      activityApi.refuelLottery().then(res => {
        if (res.data.resultCode === '0') {
          this.itemName = res.data.resultData.itemName || ''
          let prize = {
            name: this.itemName
          }
          this.rotate(prize)
        }
      })
    }
  }

}
</script>
<style lang='less' scoped>
.turntable-container{
  width: 100%;
  height: 100%;
  background-image: url('https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/refuel/refuel2-bg.png');
  background-size: 100% 100%;
}
.container-bg{
  width: 100%;
  position: absolute;
}
.turntable-box{
  //z-index: 10;
  margin: 0 20px;
  //height: 350px;
  position: relative;
  top: 240px;
  width: calc(100% - 40px);
  //background-image: url('./img/refuel2-turntable-bg.png');
  //background-size: 100% 100%;
}
.turntable-bg{
  z-index: 5;
  position: absolute;
  top: 35%;
  width: calc(100vw - 40px);
}
.turntable-center{
  position: absolute;
  z-index: 10;
  margin: 5.6% 5.8%;
  width: 88%;
  //height: ;
}
.turntable-top{
  z-index: 15;
  width: 100px;
  position: absolute;
  margin-top: 34%;
  left: calc(50% - 50px);
}
.refuel-info{
  width: 100%;
  font-size: 20px;
  text-align: center;
  position: absolute;
  top: 180px;
  text-shadow: 2px 2px 0 white, 2px -2px 0 white, -2px -2px 0 white, -2px 2px 0 white, 2px 1px 0 white, 2px -1px 0 white, -2px -1px 0 white, -2px 1px 0 white, 2px 0px 0 white, 2px 0px 0 white, -2px 0px 0 white, -2px 0px 0 white,  1px 2px 0 white, 1px -2px 0 white, -1px -2px 0 white, -1px 2px 0 white, 1px 1px 0 white, 1px -1px 0 white, -1px -1px 0 white, -1px 1px 0 white, 1px 0px 0 white, 1px 0px 0 white, -1px 0px 0 white, -1px 0px 0 white, 0px 2px 0 white, 0px -2px 0 white, 0px -2px 0 white, 0px 2px 0 white, 0px 1px 0 white, 0px -1px 0 white, 0px -1px 0 white, 0px 1px 0 white;
  //text-shadow: 3px 3px 0 white, 3px -3px 0 white, -3px -3px 0 white, -3px 3px 0 white, 3px 2px 0 white, 3px -2px 0 white, -3px -2px 0 white, -3px 2px 0 white, 3px 1px 0 white, 3px -1px 0 white, -3px -1px 0 white, -3px 1px 0 white, 3px 0px 0 white, 3px 0px 0 white, -3px 0px 0 white, -3px 0px 0 white, 2px 3px 0 white, 2px -3px 0 white, -2px -3px 0 white, -2px 3px 0 white, 2px 2px 0 white, 2px -2px 0 white, -2px -2px 0 white, -2px 2px 0 white, 2px 1px 0 white, 2px -1px 0 white, -2px -1px 0 white, -2px 1px 0 white, 2px 0px 0 white, 2px 0px 0 white, -2px 0px 0 white, -2px 0px 0 white, 1px 3px 0 white, 1px -3px 0 white, -1px -3px 0 white, -1px 3px 0 white, 1px 2px 0 white, 1px -2px 0 white, -1px -2px 0 white, -1px 2px 0 white, 1px 1px 0 white, 1px -1px 0 white, -1px -1px 0 white, -1px 1px 0 white, 1px 0px 0 white, 1px 0px 0 white, -1px 0px 0 white, -1px 0px 0 white, 0px 3px 0 white, 0px -3px 0 white, 0px -3px 0 white, 0px 3px 0 white, 0px 2px 0 white, 0px -2px 0 white, 0px -2px 0 white, 0px 2px 0 white, 0px 1px 0 white, 0px -1px 0 white, 0px -1px 0 white, 0px 1px 0 white;
  .sp{
    font-size: 32px;
    color: red;
  }
}
.btn-box{
  top: 660px;
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: space-evenly;
  img{
    width: 30%;
  }
}
.hasPrize-bg{
  position: relative;
  left: calc(50vw - 150px);
  top: 200px;
  width: 300px !important;
  //height: 200px !important;
}
.dialog-btn{
  top: 110px;
  position: relative;
  display: flex;
  z-index: 20;
  justify-content: space-evenly;
  img{
    width: 50px;
  }
}
// .warning{
//   position: absolute;
//   top: 100px;
//   z-index: 20;
//   width: 80%;
// }
.prize-container{
  z-index: 30;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.prize-box {
  margin: 0 5vw;
  width: 90vw;
  padding-top: 100px;
  height: calc(100vh - 100px);
  position: absolute;
  top: 0px;
  left: 5;
  overflow-y: auto;
  overflow-x: hidden;
  .bg {
    width: 90vw;
    z-index: 2;
  }
  .close {
    float: right;
    width: 40px;
    left: 10px;
  }
  .prize-detail {
    width: calc(100% - 80px - 5vw);
    height: 200px;
    //background-color: red;
    margin: 0 40px;
    position: relative;
    top: -240px;
    overflow-y: auto;
    overflow-x: hidden;
    .prize-item {
      font-size: 18px;
      width: 100%;
      line-height: 38px;
      display: flex;
      justify-content: space-between;
    }
    .item-status1 {
      color: rgb(210, 0, 0);
    }
    .item-status2 {
      color: rgb(11, 98, 63);
    }
  }
}
.turntable-shadow{
  position: absolute;
  width: 64%;
  top: 352px;
  left: 18%;
  z-index: 1;
}
</style>
